import React from "react";
import { NavLink, Outlet, useNavigate, Navigate } from "react-router-dom";
import { useAdminAuth } from "../../context/AdminAuthContext";
import {
  LayoutDashboard, Package, FolderTree, ShoppingCart, Users, FileText,
  Upload, MessageSquare, Settings, ScrollText, MapPin, FileEdit, UserCog,
  RotateCcw, LogOut, ExternalLink, Home, Ticket, Mail,
} from "lucide-react";

const NAV = [
  { to: "/admin", end: true, icon: LayoutDashboard, label: "Dashboard" },
  { to: "/admin/pedidos", icon: ShoppingCart, label: "Pedidos" },
  { to: "/admin/productos", icon: Package, label: "Productos" },
  { to: "/admin/categorias", icon: FolderTree, label: "Categorías" },
  { to: "/admin/clientes", icon: Users, label: "Clientes" },
  { to: "/admin/facturas", icon: FileText, label: "Facturas" },
  { to: "/admin/cupones", icon: Ticket, label: "Cupones" },
  { to: "/admin/mailings", icon: Mail, label: "Mailings" },
  { to: "/admin/devoluciones", icon: RotateCcw, label: "Devoluciones" },
  { to: "/admin/mensajes", icon: MessageSquare, label: "Mensajes" },
  { to: "/admin/importar", icon: Upload, label: "Importar CSV" },
  { to: "/admin/inicio", icon: Home, label: "Editor Inicio" },
  { to: "/admin/landings", icon: MapPin, label: "Landings SEO" },
  { to: "/admin/paginas", icon: FileEdit, label: "Páginas" },
  { to: "/admin/usuarios", icon: UserCog, label: "Usuarios" },
  { to: "/admin/configuracion", icon: Settings, label: "Configuración" },
  { to: "/admin/logs", icon: ScrollText, label: "Logs" },
];

export default function AdminLayout() {
  const { admin, loading, logout } = useAdminAuth();
  const nav = useNavigate();

  if (loading) return <div className="min-h-screen flex items-center justify-center">Cargando...</div>;
  if (!admin) return <Navigate to="/admin/login" replace />;

  return (
    <div className="min-h-screen flex bg-background">
      <aside className="w-60 bg-brand-ink text-white/70 flex flex-col shrink-0 fixed inset-y-0 left-0 overflow-y-auto no-scrollbar">
        <div className="p-5 border-b border-white/10">
          <span className="font-heading font-extrabold text-xl text-brand tracking-tighter">FABRIPAN</span>
          <p className="text-[10px] font-mono text-white/40">BACKOFFICE</p>
        </div>
        <nav className="flex-1 p-3 space-y-0.5">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end}
              className={({ isActive }) => `flex items-center gap-3 px-3 py-2 rounded-sm text-sm transition-colors ${isActive ? "bg-brand text-white" : "hover:bg-white/5 hover:text-white"}`}
              data-testid={`admin-nav-${n.label.toLowerCase().replace(/\s/g, "-")}`}>
              <n.icon className="h-4 w-4" /> {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-white/10 space-y-1">
          <a href="/" target="_blank" rel="noreferrer" className="flex items-center gap-3 px-3 py-2 rounded-sm text-sm hover:bg-white/5 hover:text-white transition-colors"><ExternalLink className="h-4 w-4" /> Ver web</a>
          <button onClick={() => { logout(); nav("/admin/login"); }} className="w-full flex items-center gap-3 px-3 py-2 rounded-sm text-sm hover:bg-white/5 hover:text-white transition-colors" data-testid="admin-logout"><LogOut className="h-4 w-4" /> Salir</button>
        </div>
      </aside>
      <div className="flex-1 ml-60 min-w-0">
        <header className="bg-white border-b border-border px-6 py-3 flex items-center justify-between sticky top-0 z-10">
          <span className="text-sm text-muted-foreground">Panel de administración</span>
          <span className="text-sm font-medium">{admin.name} <span className="text-xs font-mono text-brand">· {admin.role}</span></span>
        </header>
        <div className="p-6"><Outlet /></div>
      </div>
    </div>
  );
}
